<template>
  <div id="backup-service">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <BackupsNavBar :activeId="id" v-on:csv='downloadCSV' :downloadBtn="true" :text="`Download ${service} Report`"/>

    <div class="row">
      <div class="col-4 px-3 position-fixed" id="sticky-sidebar">
        <div class="backup-table-container">
          <transition name="fade" mode="in-out" appear>
            <vue-good-table
              :columns="resourceCols"
              :rows="resources"
              @on-row-click="onRowClick"
              :search-options="{
                enabled: true,
                skipDiacritics: true,
                placeholder: 'filter resources',
              }"
              :pagination-options="{
                enabled: true,
                perPage: 20,
                position: 'top',
              }"
              :row-style-class="rowStyleFn"
              styleClass="vgt-table condensed">
            </vue-good-table>
          </transition>
        </div>
      </div>
      <div class="col offset-4" id="main">
        <div v-if="active.id !== null">
          <div class="row">
            <div class="col">

              <transition name="fade" mode="in-out" appear>
                <div class="card">
                  <div class="card-header">
                    <div class="row">
                      <div class="col">
                        <h4>Resource Details</h4>
                      </div>
                      <div class="col">
                        <span class="float-right">Report Date: {{reportDate | moment('MMMM Do YYYY')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <dl v-html="renderResourceDetails(active)"></dl>
                  </div>
                </div>
              </transition>

              <transition name="fade" mode="in-out" appear>
                <div class="card" v-if="'shelvery_config' in active && active.shelvery_config !== null && Object.keys(active.shelvery_config).length !== 0">
                  <div class="card-header">
                    <h4>Shelvery Config</h4>
                  </div>
                  <div class="card-body">
                    <dl v-html="renderShelveryConfig(active.shelvery_config)"></dl>
                  </div>
                </div>
              </transition>

            </div>
            <div class="col-5">

              <transition name="fade" mode="in-out" appear>
                <div class="card">
                  <div class="card-header">
                    <h4>Backups By Type</h4>
                  </div>
                  <div class="card-body">
                    <div class=row>
                      <div class="col-7">
                        <backup-service-by-type :data="getBackupTypeCount()"/>
                      </div>
                      <div class="col">
                        <div class="total-backups">
                          <span class="backup-count">{{ getBackupTypeCount().reduce((a, b) => a + b, 0) }}</span>
                          <span class="backup-count-text">Total Backups</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>

            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="backup-table-container">

                <transition name="fade" mode="in-out" appear>
                  <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :search-options="{
                      enabled: true,
                      skipDiacritics: true,
                      placeholder: 'filter backups',
                    }"
                    :sort-options="{
                      initialSortBy: {
                        field: 'createdAt',
                        type: 'desc'
                      },
                    }"
                    :pagination-options="{
                      enabled: true
                    }"
                    styleClass="vgt-table condensed"/>
                </transition>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import BackupsNavBar from '@/components/BackupsNavBar'
import BackupServiceByType from '@/components/charts/BackupServiceByType'
import BackupSummaryTotal from '@/components/charts/BackupSummaryTotal'
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import CONSTANTS from '@/constants/shelvery'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'BackupService',
  components: {
    VueLoading,
    BackupsNavBar,
    BackupServiceByType,
    BackupSummaryTotal,
    VueGoodTable
  },
  props: [
    'id',
    'service'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  data () {
    return {
      reports: [],
      resources: [],
      active: {id: null},
      loading: false,
      reportDate: '',
      selectedRow: 0,
      resourceCols: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Account',
          field: 'account_name'
        },
        {
          label: 'Shelvery',
          field: 'shelvery_status'
        }
      ],
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Type',
          field: 'type'
        },
        {
          label: 'Retention',
          field: 'retention'
        },
        {
          label: 'Created On',
          field: 'createdAt',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do yyyy KK:mm a'
        },
        {
          label: 'Size (GB)',
          field: 'size',
          type: 'number'
        },
        {
          label: 'Encrypted',
          field: 'encrypted',
          type: 'boolean'
        }
      ],
      rows: []
    }
  },
  created: function () {
    this.getReport()
  },
  watch: {
    reports: function () {
      this.resources = []
      this.getResources()
      if (this.resources.length > 0) {
        this.active = this.resources[0]
      }
    },
    id: function () {
      this.reports = []
      this.active = {id: null}
      this.selectedRow = 0
      this.getReport()
    },
    service: function () {
      this.reports = []
      this.active = {id: null}
      this.selectedRow = 0
      this.getReport()
    },
    'active.id': function () {
      this.rows = []
      this.setRows()
      this.reportDate = ''
      this.setReportDate()
    }
  },
  methods: {
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Genrating Backups CSV report',
        time: 3000
      })
      HTTP.get(`/backups/${this.activeType}/${this.id}/service/${this.service}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'Backups CSV report generation complete'
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate backups CSV report : ${error.message}`
          })
        })
    },
    getReport: function () {
      this.loading = true
      HTTP.get(`/backups/${this.activeType}/${this.id}/service/${this.service}`)
        .then((response) => {
          this.reports = response.data.backups
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get ${this.service} backups report : ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getBackupTypeCount: function () {
      var data = []
      var types = ['shelvery', 'automated', 'manual', 'awsbackup']
      var backups = this.getBackups(this.active.id)

      if (!backups) {
        return data
      }

      for (var type of types) {
        var count = 0
        if (type in backups) {
          for (var key in backups[type]) {
            count += backups[type][key].length
          }
        }
        data.push(count)
      }

      return data
    },
    getShelveryBackupCount: function () {
      var data = []
      var backups = this.getBackups(this.active.id)

      if (!backups) {
        return data
      }

      if ('shelvery' in backups) {
        for (var key in backups['shelvery']) {
          data.push(backups['shelvery'][key].length)
        }
      }

      return data
    },
    getShelveryBackupLabels: function () {
      var data = []
      var backups = this.getBackups(this.active.id)

      if (!backups) {
        return data
      }

      if ('shelvery' in backups) {
        for (var key in backups['shelvery']) {
          data.push(key)
        }
      }

      return data
    },
    getBackups: function (id) {
      // Prefer the report where this resource is in report.resources (owner account with full backup list).
      for (const r of this.reports) {
        const hasResource = r.report.resources && r.report.resources.some(res => res.id === id)
        if (hasResource && id in r.report.backups) {
          return r.report.backups[id]
        }
      }
      for (const r of this.reports) {
        if (id in r.report.backups) {
          return r.report.backups[id]
        }
      }
    },
    setPeriodName: function (name) {
      if (name === 'unknown') {
        return 'all'
      }
      return name
    },
    onRowClick: function (params) {
      if (this.active.id !== params.row.id) {
        this.active = params.row
        this.selectedRow = params.row.originalIndex
      }
    },
    rowStyleFn: function (row) {
      return row.originalIndex === this.selectedRow ? 'selected-row' : ''
    },
    getResources: function () {
      for (var report of this.reports) {
        for (var resource of report.report.resources) {
          resource.account = report.account
          resource.account_name = report.account_name
          this.resources.push(resource)
        }
      }
    },
    setRows: function () {
      var backups = this.getBackups(this.active.id)

      if (!backups) {
        return
      }

      for (var type in backups) {
        for (var retention in backups[type]) {
          for (var backup of backups[type][retention]) {
            var timestamp = Math.floor(backup.date_created)
            this.rows.push({
              name: backup.name,
              id: backup.id,
              type: type,
              retention: retention,
              createdAt: timestamp,
              size: backup.size,
              encrypted: backup.encrypted
            })
          }
        }
      }
    },
    setReportDate: function () {
      for (var r of this.reports) {
        for (var resource of r.report.resources) {
          if (resource.id === this.active.id) {
            this.reportDate = r.timestamp
            return
          }
        }
      }
    },
    renderResourceDetails: function (active) {
      var html = ''
      for (var key in active) {
        var value = active[key]
        if (key === 'date_created') {
          var timestamp = Math.floor(value)
          var date = this.$moment.unix(parseInt(timestamp))
          value = date.format('MMMM Do YYYY')
        }
        if (!CONSTANTS.IGNORE_RESOURCE_KEYS.includes(key)) {
          var formattedKey = key.split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
          html += `<dt>${formattedKey}</dt><dd>${value}</dd>`
        }
      }
      return html
    },
    renderShelveryConfig: function (config) {
      var html = ''
      var keyClass = 'invalidKey'
      for (var key in config) {
        if (CONSTANTS.CONFIG_KEYS.includes(key)) {
          keyClass = 'validKey'
        }
        html += `<dt>${key}</dt><dd class="${keyClass}">${config[key]}</dd>`
      }
      return html
    }
  }
}
</script>

<style>
.row {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
}
.card {
  margin-top: 15px;
}
.snapshot-period {
  margin-top: 10px;
}
.total-backups {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.backup-count {
  font-size: 5em;
  font-weight: bold;
  display: block;
}
.backup-count-text {
  font-size: 2em;
  display: block;
}
.backup-table-container {
  margin-top: 15px;
}
.validKey {
  color: #2c3e50;
}
.invalidKey {
  color: #f070a1;
}
dl {
  display: grid;
  grid-template-columns: auto auto;
  margin: 0px;
}
dt {
  font-weight: 500;
}
dd {
  text-align: left;
  margin-bottom: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 400ms ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/BackupService.vue